import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'padStart',
})
export class PadStartPipe implements PipeTransform {
  transform(
    value: string | number,
    targetLength: number,
    padString: string
  ): string {
    const strValue = String(value);

    if (strValue.length < 2) {
      return strValue.padStart(targetLength, padString);
    }

    return strValue;
  }
}
